import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, of, Subject, BehaviorSubject, merge } from 'rxjs';
import { catchError, finalize, retry, mergeMap, map, switchMap, concatAll, share, switchAll, mergeAll, tap } from 'rxjs/operators';
import { LoadingService } from './loading.service';
import { StorageService } from './storage.service';
import { HandleErrorService } from './HandleErrorService';
import { SpinnerService } from './spinner.service';
import { environment } from 'src/environments/environment';
import { NotificationService } from './notification/notification.service';
import { Router } from '@angular/router';
import { ToastrService } from "ngx-toastr";

@Injectable()
export class FgHttpInterceptor implements HttpInterceptor {

  baseUrl = environment.BASE_API_URL_BACKEND + '/'
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  isRefreshingToken = false;
  private skipAuthUrls = [
    '/api/account/',
    '/api/account/reset-password/init',
    '/api/account/reset-password/request',
    '/api/account/reset-password/finish',
    '/login',
    'amazonaws.com'
  ];
  constructor(private error: HandleErrorService,
    private notificationService: NotificationService,
    private loadingService: LoadingService, private http: HttpClient,
    private storageService: StorageService, private spinnerService: SpinnerService,
    private router: Router,
    private toastr: ToastrService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // ✅ Skip public APIs completely
    if (this.skipAuthUrls.some(url => request.url.includes(url))) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {

        const currentUrl = this.router.url;

        // 🛑 ABSOLUTE BLOCK — never session-timeout on public pages
        if (
          currentUrl.startsWith('/login') ||
          currentUrl.startsWith('/forgot-password') ||
          currentUrl.startsWith('/reset-password') ||
          currentUrl.startsWith('/reset-mail-sent')
        ) {
          return throwError(err);
        }

        // 🔐 Session timeout ONLY if a real auth token exists
        if (err.status === 401) {

          const hasValidSession =
            !!this.storageService.getItem(StorageService.JWT_TOKEN);

          if (hasValidSession) {
            this.storageService.clear();
            this.router.navigate(['/session-timeout']);
          }

          return throwError(err);
        }

        if (err.status === 500) {
          this.notificationService.error('Server Error');
        }

        if (err.status === 0 || err.status === 503) {
          this.router.navigate(['/service-unavailable']);
        }

        return throwError(err);
      })
    );
  }
}


